import React from "react";
import { ModeOfTransport } from "@iventis/domain-model/model/modeOfTransport";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled, fontSizes, defaultSkeletonMixin } from "@iventis/styles";
import { Theme } from "@emotion/react";

import { UseIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations";
import { setModeOfTransportIconName } from "./utilities";

interface RouteDistanceProps {
    modeOfTransport: ModeOfTransport;
    travelDistance: string;
    travelTime: string;
    translate: UseIventisTranslate;
    isGeneratingRoute: boolean;
}

export const RouteDistance: React.FC<RouteDistanceProps> = ({ modeOfTransport, travelDistance, travelTime, translate, isGeneratingRoute }) =>
    isGeneratingRoute ? (
        <Skeleton data-testid="generating-route-indicator" />
    ) : (
        <StyledContainer>
            <StyledRow>
                <span>
                    <StyledIconContainer>
                        <FontAwesomeIcon icon={{ prefix: "fas", iconName: setModeOfTransportIconName(modeOfTransport) }} />
                    </StyledIconContainer>
                    {translate(Content.map7.routeGenerator.distance)}:
                </span>{" "}
                <span data-testid="route-travel-distance">{travelDistance}</span>
            </StyledRow>
            <StyledRow>
                <span>
                    <StyledIconContainer>
                        <FontAwesomeIcon icon={["fas", "clock"]} />
                    </StyledIconContainer>
                    {translate(Content.map7.routeGenerator.travelTime)}:
                </span>{" "}
                <span data-testid="route-travel-time">{travelTime}</span>
            </StyledRow>
        </StyledContainer>
    );

const StyledContainer = styled.div`
    box-sizing: border-box;
    background: ${(props: { theme: Theme }) => props.theme.tertiaryColors.primaryBackground};
    width: 100%;
    border-radius: 4px;
    padding: 10px 20px;
    font-size: ${fontSizes.medium};
    font-weight: 500;
`;

const StyledRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
`;

const StyledIconContainer = styled.span`
    display: inline-block;
    text-align: center;
    width: 16px;
    margin-right: 10px;
`;

const Skeleton = styled(StyledContainer)`
    ${defaultSkeletonMixin}
    height: 100px;
`;
